import { TooltipProvider } from '@/components/ui/tooltip';
import { PwaInstallProvider } from '@/hooks/use-pwa-install';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthProvider';
import { CompanyProvider } from './contexts/CompanyProvider';
import { SystemNotificationProvider } from './contexts/SystemNotificationProvider';
import { queryClient } from './lib/query-client';
import AppRoutes from './routes/AppRoutes';

const App = () => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <CompanyProvider>
            <SystemNotificationProvider>
              <PwaInstallProvider>
                <Toaster />
                <AppRoutes />
              </PwaInstallProvider>
            </SystemNotificationProvider>
          </CompanyProvider>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
